import { AadeSyncStatus } from '@biorec/admin/domain';
import { Signal } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { debounceTime } from "rxjs";

export function isNullOrUndefined(value: any) {
	return value === null || value === undefined;
}

export function resolveAadeStatusIcon(item: {
	aadeStatus?: AadeSyncStatus;
	[key: string]: any;
}) {
	switch (item.aadeStatus) {
		case AadeSyncStatus.Success:
			return 'mdi mdi-check-circle text-green-500 mdi-24px';
		case AadeSyncStatus.Error:
			return 'mdi mdi-close-circle text-red-500 mdi-24px';
		case AadeSyncStatus.Sync:
			return 'mdi mdi-sync-circle text-yellow-500 mdi-24px'
	}
	return 'minus';
}

export function resolveAadeStatusTooltip(item: {
	aadeResponse?: any;
	aadeStatus?: AadeSyncStatus;
	[key: string]: any;
}) {
	const aadeResponse = item.aadeResponse || {};
	switch (item.aadeStatus) {
		case AadeSyncStatus.Error:
			if (aadeResponse?.errors?.error) {
				return (aadeResponse.errors.error as [])
					.map((err: { [key: string]: any }) =>
						err.message
							? `<p style="overflow-wrap: anywhere;">${err.message}</p>`
							: ''
					)
					.filter((m) => m)
					.join('<br />');
			}
			break;
		case AadeSyncStatus.Success:
			return `<span style="overflow-wrap: anywhere;">
				invoiceUid: ${aadeResponse.invoiceUid || ''}<br />
				statusCode: ${aadeResponse.statusCode || ''}<br />
				invoiceMark: ${aadeResponse.invoiceMark || ''}</span>`;
		case AadeSyncStatus.Sync:
			return $localize`Record is pending synchronization`;
	}
	return '';
	// TODO; add way the span to take method onClick,
}

/** Simple check and minus based on boolean */
export function resolveCheckOrMinusIcon(condition: boolean) {
	return condition ? 'mdi mdi-check' : 'mdi mdi-minus';
}

export function resolveIconByCondition(condition: boolean) {
	/*
		If condition == true { green check icon },
		If condition != true { red cross icon }
		Can be used in many cases if needed
	*/
	if (condition) {
		return 'mdi mdi-check p-badge p-badge-success flex border-circle w-1rem justify-content-center h-1.4rem';
	} else {
		return 'mdi mdi-close p-badge p-badge-danger flex border-circle w-1rem justify-content-center h-1.4rem';
	}
}

/**
 * Creates a debounced signal from a source signal.
 * Prevents frequent BE requests by delaying for a set amount of time.
 */
export function debouncedSignal<T>(sourceSignal: Signal<T>, debounceDelay: number) {
	const signalObs = toObservable(sourceSignal);
	return toSignal(signalObs.pipe(debounceTime(debounceDelay)));
}

export function formatLocalDate(date?: string | null) {
	if (!date) {
		return '—';
	}
	const [y, m, d] = date.split('-').map(Number);
	return new Date(y, m - 1, d).toLocaleDateString();
}
